import { ProjectDemoData } from './types';

// 把当前项目数据序列化为请求负载，由服务端构建 LLM 系统提示词
// （不含预置回复，避免污染模型输出）
// buildProjectAIContext：AI策略专用白名单上下文
// 只包含业务事实与投放数据，不传 UI 配置 / CSS / 路由 / 图片 / Mock 回答
// 注意：当前 Demo 由前端提供上下文；生产版应将 Project Context 移到服务器端数据源，
// 避免依赖客户端提供事实（见 HANDOFF.md）
export const buildProjectAIContext = (project: ProjectDemoData) => ({
  项目基础信息: {
    名称: project.name,
    品类: project.category,
    当前阶段: project.currentStage,
    初始化类型: project.initType,
    目标媒体: project.targetMedia,
    业务目标: project.businessObjective,
  },
  产品核心认知: project.productUnderstanding,
  Business_Brief: project.learningWorkflow.brief,
  素材学习结论: project.learningWorkflow.materialLearning,
  当前策略: project.learningWorkflow.strategySummary,
  投放数据: project.optimization,
  Product_Skill: project.productSkill,
});
